import { Card, Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import HighlightedCode from "examples/HighlightedCode";
import DataTable from "examples/Tables/DataTable";
import React from "react";
import sampleResponses from "static-data/sample-responses";
import useCopyToClipboard from "../../../../custom-hooks/useCopyToClipboard";
import MDButton from "components/MDButton";
import { ContentCopy } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import PropTypes from "prop-types";

const ApiDescription = ({ data, search }) => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [, copy] = useCopyToClipboard();

  const filter = () => {
    return data?.filter((childVal) => {
      if (search?.toLowerCase() === "") {
        return childVal;
      }
      const q = search.toLowerCase();
      return (
        childVal?.mainHeading?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingStatic?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDesc?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescTwo?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescThree?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescStatic?.toLowerCase()?.includes(q) ||
        childVal?.mainHeadingDescStaticTwo?.toLowerCase()?.includes(q) ||
        childVal?.endPointDesc?.toLowerCase()?.includes(q)
      );
    });
  };

  const filtered = filter();
  const themeMode = darkMode ? "dark-tbl" : "light-tbl";

  const renderSampleCode = () => null;

  return (
    <>
      {filtered.length === 0 && (
        <MDTypography
          variant="h3"
          fontWeight="regular"
          fontFamily="inherit"
          textAlign="center"
          lineHeight={2}
          id="no-data-found"
        >
          No Results Found!
        </MDTypography>
      )}
      {filtered.length > 0 &&
        filtered.map((childVal, idx) => {
          return (
            <React.Fragment key={childVal.mainGridIdStatic || childVal.mainGridId || idx}>
              {childVal.mainGridIdStatic && !childVal.navLabel && (
                <Grid
                  container
                  xs={12}
                  mt={4}
                  id={childVal.mainGridIdStatic}
                >
                  {childVal.mainHeadingStatic && (
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={1.5}
                      className="section"
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStatic && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingDescStatic}
                    </MDTypography>
                  )}
                  {childVal.mainHeadingDescStaticTwo && (
                    <MDTypography
                      variant="p"
                      fontSize="14px"
                      fontWeight="regular"
                      fontFamily="inherit"
                      lineHeight={2}
                      width="100%"
                      display="block"
                    >
                      {childVal.mainHeadingDescStaticTwo}
                    </MDTypography>
                  )}
                  {childVal.staticTables &&
                    childVal.staticTables.map((tbl, ti) => (
                      <Grid
                        key={ti}
                        item
                        xs={12}
                        md={tbl.half ? 8 : 12}
                      >
                        <MDBox mt={3} className="table-doc" width="100%">
                          <Card>
                            <MDBox className={themeMode}>
                              <Table>
                                <MDBox
                                  component="thead"
                                  sx={{ background: "#F6F8FA" }}
                                >
                                  <TableRow>
                                    {tbl.columns.map((col) => (
                                      <TableCell
                                        key={col.accessor}
                                        align={col.align || "left"}
                                        sx={{
                                          width: col.width || "auto",
                                          fontWeight: 700,
                                          color: "#022DEC",
                                          textTransform: "uppercase",
                                          fontSize: "0.75rem",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {col.Header}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </MDBox>
                                <TableBody>
                                  {tbl.rows.map((row, ri) => (
                                    <TableRow key={ri}>
                                      {tbl.columns.map((col) => (
                                        <TableCell
                                          key={col.accessor}
                                          align={col.align || "left"}
                                          sx={{ verticalAlign: "top" }}
                                        >
                                          {row[col.accessor]}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </MDBox>
                          </Card>
                        </MDBox>
                      </Grid>
                    ))}
                  {childVal.responseSplits &&
                    childVal.responseSplits.map((sp, si) => (
                      <Grid
                        key={si}
                        container
                        item
                        xs={12}
                        spacing={3}
                        mt={si === 0 ? 1 : 2}
                        alignItems="flex-start"
                      >
                        <Grid item xs={12} md={8}>
                          <p
                            className={`staus-code ${sp.statusClass}`}
                            style={{ display: "inline-block", margin: 0 }}
                          >
                            {sp.status}
                          </p>
                          <MDTypography
                            variant="p"
                            fontSize="14px"
                            fontWeight="regular"
                            fontFamily="inherit"
                            lineHeight={2}
                            sx={{ display: "block", mt: 1 }}
                          >
                            {sp.details}
                          </MDTypography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <MDTypography variant="h6" fontWeight="regular">
                            Response Object
                          </MDTypography>
                          <HighlightedCode code={sp.code} />
                        </Grid>
                      </Grid>
                    ))}
                </Grid>
              )}

              {childVal.mainHeading && (
                <MDBox id={childVal.mainGridId}>
                <Grid
                  container
                  xs={12}
                  mt={4}
                >
                  <Grid
                    item
                    xs={12}
                    md={8}
                    pr={2}
                    className="section"
                  >
                    <MDTypography
                      variant="h4"
                      fontWeight="bold"
                      fontFamily="inherit"
                      lineHeight={2}
                      className="section"
                    >
                      {childVal.mainHeading}
                    </MDTypography>
                    {childVal.mainHeadingDesc && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDesc}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.introTable && (
                      <MDBox mt={2} mb={2} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.introTable.columns,
                                rows: childVal.introTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.mainHeadingDescTwo && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.mainHeadingDescTwo}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.mainHeadingDescThree && (
                      <p>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          <b>NOTE: </b>
                          {childVal.mainHeadingDescThree}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.endpointId && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        id={childVal.endpointId}
                        className="section"
                      >
                        {childVal.endPointHeading}
                      </MDTypography>
                    )}
                    {childVal.endPointMethod && (
                      <MDTypography
                        variant="h6"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={1}
                        className={
                          childVal.endPointMethod === "GET"
                            ? "post-badge get"
                            : "post-badge"
                        }
                      >
                        {childVal.endPointMethod}
                      </MDTypography>
                    )}
                    {childVal.endPointDesc && (
                      <>
                        <MDTypography
                          variant="h6"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={1}
                          className="link-badge"
                        >
                          {childVal.endPointDesc}
                          <MDButton
                            variant="text"
                            className="copyiconparent"
                            onClick={() => copy(childVal.endPointDesc)}
                          >
                            <ContentCopy className="copyicon" />
                          </MDButton>
                        </MDTypography>
                        <br />
                      </>
                    )}
                    {childVal.requestHeader && (
                      <>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          mt={3}
                          lineHeight={2}
                          id={childVal.requestHeaderId}
                          className="section"
                        >
                          {childVal.requestHeader}
                        </MDTypography>
                        <MDBox mt={3} className="table-doc">
                          <Card>
                            <MDBox className={themeMode}>
                              <DataTable
                                table={{
                                  columns: childVal.requestHeaderTable.columns,
                                  rows: childVal.requestHeaderTable.rows,
                                }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                              />
                            </MDBox>
                          </Card>
                        </MDBox>
                      </>
                    )}
                    {childVal?.SampleCode && (
                      <MDBox mt={3}>
                        <MDTypography
                          variant="h5"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.SampleCodeTitle}
                        </MDTypography>
                        {renderSampleCode(childVal.sampleCodeType)}
                        {childVal.sampleCodeNote && (
                          <p style={{ marginTop: "15px" }}>
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                            >
                              <b>Note: </b>
                              {childVal.sampleCodeNote}
                            </MDTypography>
                          </p>
                        )}
                      </MDBox>
                    )}
                  </Grid>
                </Grid>

              {childVal.bodyBlocks &&
                childVal.bodyBlocks.some((b) => b.zone === "lead") && (
                <Grid container xs={12} mt={2}>
                  <Grid item xs={12} className="section">
                    {childVal.bodyBlocks
                      .flatMap((blk, bi) => blk.zone === "lead" ? [{ blk, bi }] : [])
                      .map(({ blk, bi }) => (
                        <MDBox key={bi} mt={blk.heading ? 3 : 2}>
                          {blk.heading && (
                            <MDTypography
                              variant="h5"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              className="section"
                              id={`${childVal.mainGridId}-blk-${bi}`}
                            >
                              {blk.heading}
                            </MDTypography>
                          )}
                          {blk.list && (
                            <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                              {blk.list.map((li, li2) => (
                                <li key={li2}>
                                  <MDTypography
                                    variant="p"
                                    fontSize="14px"
                                    fontWeight="regular"
                                    fontFamily="inherit"
                                    lineHeight={2}
                                  >
                                    {typeof li === "string" ? li : li.label}
                                  </MDTypography>
                                  {typeof li === "object" && li.subItems && (
                                    <ul style={{ paddingLeft: "20px" }}>
                                      {li.subItems.map((sub, si) => (
                                        <li key={si}>
                                          <MDTypography
                                            variant="p"
                                            fontSize="14px"
                                            fontWeight="regular"
                                            fontFamily="inherit"
                                            lineHeight={2}
                                          >
                                            {sub}
                                          </MDTypography>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                          {blk.code && (
                            <MDBox mt={2} sx={{ maxWidth: { md: "66%" } }}>
                              <MDBox
                                sx={{ "& > div": { maxHeight: { md: "70vh" }, overflow: "auto" } }}
                              >
                                <HighlightedCode code={blk.code.trim()} />
                              </MDBox>
                            </MDBox>
                          )}
                          {blk.table && (
                            <MDBox mt={2} className="table-doc" sx={{ maxWidth: { md: "66%" } }}>
                              <Card>
                                <MDBox className={themeMode}>
                                  <DataTable
                                    table={{
                                      columns: blk.table.columns,
                                      rows: blk.table.rows,
                                    }}
                                    isSorted={false}
                                    entriesPerPage={false}
                                    showTotalEntries={false}
                                    noEndBorder
                                  />
                                </MDBox>
                              </Card>
                            </MDBox>
                          )}
                        </MDBox>
                      ))}
                  </Grid>
                </Grid>
              )}

              {(childVal.requestBody || childVal.bodyBlocks) && (
                <Grid container xs={12} mt={2} id={childVal.requestBodyId}>
                  <Grid
                    item
                    xs={12}
                    md={8}
                    pr={2}
                    className="section"
                  >
                    {childVal.requestBody && (
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        className="section"
                      >
                        {childVal.requestBody}
                      </MDTypography>
                    )}
                    {childVal.requestBodyTable && (
                      <MDBox mt={3} className="table-doc">
                        <Card>
                          <MDBox className={themeMode}>
                            <DataTable
                              table={{
                                columns: childVal.requestBodyTable.columns,
                                rows: childVal.requestBodyTable.rows,
                              }}
                              isSorted={false}
                              entriesPerPage={false}
                              showTotalEntries={false}
                              noEndBorder
                            />
                          </MDBox>
                        </Card>
                      </MDBox>
                    )}
                    {childVal.requestBodyNote && (
                      <p style={{ marginTop: "15px" }}>
                        <MDTypography
                          variant="p"
                          fontSize="14px"
                          fontWeight="regular"
                          fontFamily="inherit"
                          lineHeight={2}
                        >
                          {childVal.requestBodyNote}
                        </MDTypography>
                      </p>
                    )}
                    {childVal.bodyBlocks &&
                      childVal.bodyBlocks
                        .flatMap((blk, bi) => (blk.zone !== "lead" && blk.zone !== "rightcode") ? [{ blk, bi }] : [])
                        .map(({ blk, bi }) => {
                        const codeOnly =
                          blk.code && !blk.table && !blk.text && !blk.list;
                        return (
                          <MDBox
                            key={bi}
                            mt={blk.heading ? 3 : 2}
                            sx={codeOnly ? { display: { md: "none" } } : undefined}
                          >
                            {blk.heading && (
                              <MDTypography
                                variant="h5"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={2}
                                className="section"
                                id={`${childVal.mainGridId}-blk-${bi}`}
                              >
                                {blk.heading}
                              </MDTypography>
                            )}
                            {blk.text && (
                              <p style={{ marginTop: "8px" }}>
                                <MDTypography
                                  variant="p"
                                  fontSize="14px"
                                  fontWeight="regular"
                                  fontFamily="inherit"
                                  lineHeight={2}
                                >
                                  {blk.text}
                                </MDTypography>
                              </p>
                            )}
                            {blk.list && (
                              <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                                {blk.list.map((li, li2) => (
                                  <li key={li2}>
                                    <MDTypography
                                      variant="p"
                                      fontSize="14px"
                                      fontWeight="regular"
                                      fontFamily="inherit"
                                      lineHeight={2}
                                    >
                                      {typeof li === "string" ? li : li.label}
                                    </MDTypography>
                                    {typeof li === "object" && li.subItems && (
                                      <ul style={{ paddingLeft: "20px" }}>
                                        {li.subItems.map((sub, si) => (
                                          <li key={si}>
                                            <MDTypography
                                              variant="p"
                                              fontSize="14px"
                                              fontWeight="regular"
                                              fontFamily="inherit"
                                              lineHeight={2}
                                            >
                                              {sub}
                                            </MDTypography>
                                          </li>
                                        ))}
                                      </ul>
                                    )}
                                  </li>
                                ))}
                              </ul>
                            )}
                            {blk.code && (
                              <MDBox mt={2}>
                                <HighlightedCode code={blk.code.trim()} />
                              </MDBox>
                            )}
                            {blk.table && (
                              <MDBox mt={2} className="table-doc">
                                <Card>
                                  <MDBox className={themeMode}>
                                    <DataTable
                                      table={{
                                        columns: blk.table.columns,
                                        rows: blk.table.rows,
                                      }}
                                      isSorted={false}
                                      entriesPerPage={false}
                                      showTotalEntries={false}
                                      noEndBorder
                                    />
                                  </MDBox>
                                </Card>
                              </MDBox>
                            )}
                          </MDBox>
                        );
                      })}
                  </Grid>

                  {childVal.bodyBlocks &&
                    childVal.bodyBlocks.some((b) => b.zone === "rightcode") && (
                    <Grid item xs={12} md={4}>
                      <MDBox
                        sx={{
                          position: { md: "sticky" },
                          top: { md: 20 },
                        }}
                      >
                        {childVal.bodyBlocks
                          .flatMap((blk, bi) => blk.zone === "rightcode" ? [{ blk, bi }] : [])
                          .map(({ blk: b, bi: ci }) => (
                            <MDBox
                              key={ci}
                              mb={2}
                              sx={{
                                "& > div": {
                                  maxHeight: { md: "70vh" },
                                  overflow: "auto",
                                },
                              }}
                            >
                              {b.heading && (
                                <MDTypography variant="h6" fontWeight="regular" id={`${childVal.mainGridId}-blk-${ci}`}>
                                  {b.heading}
                                </MDTypography>
                              )}
                              <HighlightedCode code={b.code.trim()} />
                            </MDBox>
                          ))}
                      </MDBox>
                    </Grid>
                  )}

                  {childVal.requestObject && (
                    <Grid item xs={12} md={4} id={`${childVal.mainGridId}-request-object`}>
                      <MDBox
                        sx={{
                          position: { md: "sticky" },
                          top: { md: 20 },
                        }}
                      >
                        <MDTypography variant="h6" fontWeight="regular">
                          Request Object
                        </MDTypography>
                        <HighlightedCode code={childVal.requestObject.trim()} />
                      </MDBox>
                    </Grid>
                  )}

                  {childVal.respObjKey && sampleResponses.grisk?.[childVal.respObjKey] && !childVal.responseTables && (
                    <Grid item xs={12} md={4}>
                      <MDTypography variant="h6" fontWeight="regular">
                        Response Object
                      </MDTypography>
                      <HighlightedCode
                        code={sampleResponses.grisk[childVal.respObjKey].trim()}
                      />
                    </Grid>
                  )}
                </Grid>
              )}

              {childVal.responseTables && (
                <MDBox id={`${childVal.mainGridId}-response`}>
                  <Grid container xs={12} mt={2}>
                    <Grid item xs={12} className="section">
                      <MDTypography
                        variant="h5"
                        fontWeight="regular"
                        fontFamily="inherit"
                        lineHeight={2}
                        className="section"
                      >
                        Response Body
                      </MDTypography>
                    </Grid>
                  </Grid>
                  {childVal.responseTables.map((rt, ri) => {
                    const successObj =
                      ri === 0 &&
                      childVal.respObjKey &&
                      sampleResponses.grisk?.[childVal.respObjKey];
                    const rightCode = rt.code || successObj;
                    return (
                      <Grid container xs={12} mt={2} key={ri} id={rt.status ? `${childVal.mainGridId}-response-${ri}` : undefined}>
                        <Grid item xs={12} md={8} pr={2} className="section">
                          {rt.status && (
                            <p
                              className={`staus-code ${rt.statusClass || ""}`}
                              style={{ display: "inline-block", margin: 0 }}
                            >
                              {rt.status}
                            </p>
                          )}
                          {rt.tableTitle && (
                            <MDTypography
                              variant="h6"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              sx={{ display: "block", mt: 2 }}
                              id={`${childVal.mainGridId}-response-${ri}-tabletitle`}
                            >
                              {rt.tableTitle}
                            </MDTypography>
                          )}
                          {rt.title && (
                            <MDTypography
                              variant="p"
                              fontSize="14px"
                              fontWeight="regular"
                              fontFamily="inherit"
                              lineHeight={2}
                              sx={{ display: "block", mt: 2 }}
                              id={!rt.status ? `${childVal.mainGridId}-response-${ri}-title` : undefined}
                            >
                              {rt.title}
                            </MDTypography>
                          )}
                          {rt.list && (
                            <ul style={{ marginTop: "8px", paddingLeft: "20px" }}>
                              {rt.list.map((li, li2) => (
                                <li key={li2}>
                                  <MDTypography
                                    variant="p"
                                    fontSize="14px"
                                    fontWeight="regular"
                                    fontFamily="inherit"
                                    lineHeight={2}
                                  >
                                    {typeof li === "string" ? li : li.label}
                                  </MDTypography>
                                  {typeof li === "object" && li.subItems && (
                                    <ul style={{ paddingLeft: "20px" }}>
                                      {li.subItems.map((sub, si) => (
                                        <li key={si}>
                                          <MDTypography
                                            variant="p"
                                            fontSize="14px"
                                            fontWeight="regular"
                                            fontFamily="inherit"
                                            lineHeight={2}
                                          >
                                            {sub}
                                          </MDTypography>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                          {rt.table && (
                            <MDBox mt={2} className="table-doc">
                              <Card>
                                <MDBox className={themeMode}>
                                  <DataTable
                                    table={{
                                      columns: rt.table.columns,
                                      rows: rt.table.rows,
                                    }}
                                    isSorted={false}
                                    entriesPerPage={false}
                                    showTotalEntries={false}
                                    noEndBorder
                                  />
                                </MDBox>
                              </Card>
                            </MDBox>
                          )}
                          {rt.tables && rt.tables.map((tbl, ti) => (
                            <MDBox key={ti} mt={3}>
                              {tbl.title && (
                                <MDTypography
                                  variant="h6"
                                  fontWeight="regular"
                                  fontFamily="inherit"
                                  lineHeight={2}
                                  sx={{ display: "block", mt: 1 }}
                                >
                                  {tbl.title}
                                </MDTypography>
                              )}
                              <MDBox mt={1} className="table-doc">
                                <Card>
                                  <MDBox className={themeMode}>
                                    <DataTable
                                      table={{
                                        columns: tbl.columns,
                                        rows: tbl.rows,
                                      }}
                                      isSorted={false}
                                      entriesPerPage={false}
                                      showTotalEntries={false}
                                      noEndBorder
                                    />
                                  </MDBox>
                                </Card>
                              </MDBox>
                            </MDBox>
                          ))}
                          {rt.tip && (
                            <p style={{ marginTop: "15px" }}>
                              <MDTypography
                                variant="p"
                                fontSize="14px"
                                fontWeight="regular"
                                fontFamily="inherit"
                                lineHeight={2}
                              >
                                <b>Tip: </b>{rt.tip}
                              </MDTypography>
                            </p>
                          )}
                        </Grid>
                        {rightCode && (
                          <Grid item xs={12} md={4}>
                            <MDBox
                              sx={{
                                position: { md: "sticky" },
                                top: { md: 20 },
                              }}
                            >
                              {successObj && (
                                <MDTypography variant="h6" fontWeight="regular">
                                  Response Object
                                </MDTypography>
                              )}
                              <MDBox
                                sx={{
                                  "& > div": {
                                    maxHeight: { md: "70vh" },
                                    overflow: "auto",
                                  },
                                }}
                              >
                                <HighlightedCode code={rightCode.trim()} />
                              </MDBox>
                            </MDBox>
                          </Grid>
                        )}
                      </Grid>
                    );
                  })}
                </MDBox>
              )}
                </MDBox>
              )}
            </React.Fragment>
          );
        })}
    </>
  );
};
ApiDescription.propTypes = {
  data: PropTypes.array.isRequired,
  search: PropTypes.string.isRequired,
};
export default ApiDescription;
